if (!customElements.get('wr-hero-carousel')) {
  class WrHeroCarousel extends HTMLElement {
    connectedCallback() {
      if (this.initialized || this.initializing) return;

      this.initializing = true;
      window.requestAnimationFrame(() => this.initialize());
    }

    initialize() {
      if (this.initialized) return;

      this.initializing = false;
      this.initialized = true;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.carouselEnabled = this.dataset.carouselEnabled === 'true';
      this.autoplay = this.dataset.autoplay === 'true';
      this.autoplayMobile = this.dataset.autoplayMobile === 'true';
      this.pauseOnHover = this.dataset.pauseOnHover === 'true';
      this.delay = Number(this.dataset.delay || 4000);
      this.isMobile = window.matchMedia('(max-width: 768px)').matches;
      this.slides = Array.from(this.querySelectorAll('[data-wrhc-slide]'));
      this.currentIndex = 0;
      this.intervalId = null;

      if (this.slides.length === 0) {
        this.initialized = false;
        return;
      }

      this.handleResize = () => {
        const wasMobile = this.isMobile;
        this.isMobile = window.matchMedia('(max-width: 768px)').matches;

        if (wasMobile === this.isMobile) return;

        this.stop();
        this.start();
      };

      if (!this.carouselEnabled || this.reducedMotion || this.slides.length < 2) return;

      window.addEventListener('resize', this.handleResize);
      this.start();

      if (this.pauseOnHover) {
        this.addEventListener('mouseenter', this.handleMouseEnter);
        this.addEventListener('mouseleave', this.handleMouseLeave);
        this.addEventListener('touchstart', this.handleMouseEnter, { passive: true });
        this.addEventListener('touchend', this.handleMouseLeave, { passive: true });
      }
    }

    disconnectedCallback() {
      this.initializing = false;
      this.stop();
      window.removeEventListener('resize', this.handleResize);

      if (this.pauseOnHover) {
        this.removeEventListener('mouseenter', this.handleMouseEnter);
        this.removeEventListener('mouseleave', this.handleMouseLeave);
        this.removeEventListener('touchstart', this.handleMouseEnter);
        this.removeEventListener('touchend', this.handleMouseLeave);
      }
    }

    handleMouseEnter = () => {
      this.stop();
    };

    handleMouseLeave = () => {
      this.start();
    };

    start() {
      if ((this.isMobile && !this.autoplayMobile) || !this.autoplay || this.intervalId) return;

      this.intervalId = window.setInterval(() => {
        this.showNext();
      }, this.delay);
    }

    stop() {
      if (!this.intervalId) return;

      window.clearInterval(this.intervalId);
      this.intervalId = null;
    }

    showNext() {
      const currentSlide = this.slides[this.currentIndex];
      const nextIndex = (this.currentIndex + 1) % this.slides.length;
      const nextSlide = this.slides[nextIndex];

      currentSlide.classList.remove('is-active');
      nextSlide.classList.add('is-active');
      this.currentIndex = nextIndex;
    }
  }

  customElements.define('wr-hero-carousel', WrHeroCarousel);
}
